import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';
import React from 'react';

import {render} from 'react-dom'
import {createStore, applyMiddleware, compose} from 'redux'
import {Provider} from 'react-redux'
import thunk from 'redux-thunk';
import ErrorBoundary from '../../src/error_boundary.jsx'
import logger from 'redux-logger'
import cabelcar from 'redux-cablecar'
import rootReducer from '../../src/public/registration_page/reducers'
import RegistrationPage from '../../src/public/registration_page/containers/registration_page.jsx'

'use strict';
import {enableES5} from "immer"

enableES5()

document.addEventListener('DOMContentLoaded', () => {
    const node = document.getElementById('react_container')

    let dataState = JSON.parse(node.getAttribute('data'))

    let initialState = $.extend({}, dataState, {})

    console.log("Initial State", initialState)
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const store = createStore(rootReducer, initialState,
        composeEnhancers(
            applyMiddleware(cabelcar),
            applyMiddleware(logger),
            applyMiddleware(thunk)
        )
    )

    render(
        <ErrorBoundary>
            <Provider store={store}>
                <RegistrationPage/>
            </Provider>
        </ErrorBoundary>,
        node
    );
});
